import { useClearUserData } from "@app/helpers";
import React from "react";
import type { Properties } from "./properties";
import { SessionExpiredModalView } from "./session-expired-modal-view";

export const SessionExpiredModal = (props: Properties) => {
	// #region HOOKS
	const [clearUserData] = useClearUserData();

	return <SessionExpiredModalView {...props} onClose={props.onClose} />;
};
